import holidayCSS from "./holiday.css?raw"
import picoCSS from "./pico.css?raw"
import sakuraCSS from "./sakura.css?raw"
import simpleCSS from "./simple.css?raw"
import waterCSS from "./water.css?raw"
import baseCSS from "./base.css?raw"

export const base = {
  label: {_: "Base"},
  source: baseCSS
}
export const water = {
  label: {_: "Water"},
  source: waterCSS
}
export const simple = {
  label: {_: "Simple"},
  source: simpleCSS
}
export const sakura = {
  label: {_: "Sakura"},
  source: sakuraCSS
}
export const pico = {
  label: {_: "Pico"},
  source: picoCSS
}
export const holiday = {
  label: {_: "Holiday"},
  source: holidayCSS
}